import { conversationReducer, mediaProgressReducer } from './conversation';
import { draftReducer } from './draft';
import { groupParticipantsReducer } from './groupParticipants';
import { presenceDataReducer } from './lastSeen';
import { mediaPreviewReducer } from './mediaPreview';
import { recentChatReducer } from './recentChat';
import { repliedMessagesReducer } from './repliedMessages';
import { starredMessagesReducer } from './starredMessages';

export const chatReducers = {
   recentChatData: recentChatReducer,
   groupParticipantsData: groupParticipantsReducer,
   conversationData: conversationReducer,
   draftData: draftReducer,
   mediaProgressData: mediaProgressReducer,
   mediaPreviewData: mediaPreviewReducer,
   presenceData: presenceDataReducer,
   repliedMessagesData: repliedMessagesReducer,
   starredMessagesData: starredMessagesReducer,
};

export * from './conversation';
export * from './repliedMessages';
export * from './recentChat';
export * from './starredMessages';
